<div style="padding: 10px; display: flex !important; justify-content: right !important; align-items: center">
    <eris-menu [menuConfiguration]="menuConfiguration"></eris-menu>
    <div style="width: 10px;"></div>
    <div style="height: 40px;">
        <ngb-pagination (pageChange)="setPage($event)" [collectionSize]="rowsCount" [pageSize]="dataSource.pageSize"
            [(page)]="currentPage" [maxSize]="5" [boundaryLinks]="true">
        </ngb-pagination>
    </div>
</div>
<table class="table table-striped">
    <thead>
        <tr>
            <th scope="col" [class]="!!fieldDefinition.headerClass ? fieldDefinition.headerClass : ''"
                *ngFor="let fieldDefinition of dataSource.tableDefinition">
                <ng-container *ngIf="fieldDefinition.enableSort"><a href="javascript:;"
                        (click)="sortData(fieldDefinition.sortFieldName, fieldDefinition.sortDefaultFieldValue)">{{fieldDefinition.headerDescription}}</a></ng-container>
                <ng-container *ngIf="!fieldDefinition.enableSort">{{fieldDefinition.headerDescription}}</ng-container>
                <ng-container *ngIf="!!currentSortFieldName && fieldDefinition.sortFieldName == currentSortFieldName">
                    <i class="pe-7s-angle-up" *ngIf="isCurrentSortAscending"
                        style="font-size: 1.5rem;vertical-align: middle;"></i>
                    <i class="pe-7s-angle-down" *ngIf="!isCurrentSortAscending"
                        style="font-size: 1.5rem;vertical-align: middle;"></i>
                </ng-container>
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-content></ng-content>
    </tbody>
</table>
<!-- *ngIf="showPagination()" -->
<div style="display: flex !important; justify-content: right !important;">
    <ngb-pagination (pageChange)="setPage($event)" [collectionSize]="rowsCount" [pageSize]="dataSource.pageSize"
        [(page)]="currentPage" [maxSize]="5" [boundaryLinks]="true">
    </ngb-pagination>
</div>